export default function ScriptsHome() {
    return (
        <div>
            <span>Icecat Customized Reports Scripts page coming soon...</span>
        </div>
    )
}